import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { SkillRule } from "@app/models/rest/skill-rule";
import { SkillRuleRestService } from "@app/services/hal/skill-rule-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class SkillRuleStore extends RealTimeDataStore<SkillRule> {
  constructor() {
    const skillRuleRestService = inject(SkillRuleRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(skillRuleRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("SkillRule");
  }
}
